import { createView } from "../../views"

const { default: PageBaseBackgroundView } = createView('page-base-background-view');

export const PageBaseBackgroundCard = ({ children }: any) =>
  <PageBaseBackgroundView>
    {children}
  </PageBaseBackgroundView>